import { z } from 'zod';
import { emailValidationSchema } from '@/schemas/ValidationSchema.ts';

export const loginSchema = z.object({
  email: emailValidationSchema,
  password: z.string().min(1, 'Hasło jest wymagane'),
});

export type LoginFormData = z.infer<typeof loginSchema>;
